import React from 'react';
import { Route, Routes } from 'react-router';
import { PagePath } from '../navigation.enums';
import { DepartmentsCMSPage } from '../../pages/user-management/departments/departments.cms.page';
import { DepartmentTeamsCMSPage } from '../../pages/user-management/teams/department-teams.cms.page';
import { DepartmentPeopleCMSPage } from '../../pages/user-management/people/pages/department-people.cms.page';
import { CompanyTeamsCMSPage } from '../../pages/user-management/teams/company-teams.cms.page';
import { TeamPeopleCMSPage } from '../../pages/user-management/people/pages/team-people.cms.page';
import { CompanyPeopleCMSPage } from '../../pages/user-management/people/pages/company-people.cms.page';
import { OrganizationLevelType } from '../../enums';
import { PermissionType } from '../../enums/permission-type';
import { PageGuard } from '../guards/page.guard';
import { ActiveCompanySlugRedirect } from './routers.helpers';
import { useCompanySlugParamChange } from '../../library/hooks/useCompanySlugParamChange';
import { BulkAddPeople } from '../../pages/user-management/people/bulk-upload/bulk-add-people/bulk-add-people';

export function UserManagementRouter(): JSX.Element {
  useCompanySlugParamChange(PagePath.userManagementBase);

  return (
    <Routes>
      <Route path={PagePath.userManagementPeople} element={<CompanyPeopleCMSPage />} />

      <Route path={PagePath.userManagementPeopleBulkUpload} element={<BulkAddPeople />} />
      <Route
        path={PagePath.userManagementDepartments}
        element={
          <PageGuard
            organizationLevelTypesRequired={{
              permissionType: PermissionType.Administration,
              organizationLevels: [
                { organizationLevelType: OrganizationLevelType.Company, multipleEntities: false },
                { organizationLevelType: OrganizationLevelType.Department, multipleEntities: true },
              ],
            }}
          >
            <DepartmentsCMSPage />
          </PageGuard>
        }
      />
      <Route
        path={PagePath.userManagementDepartmentTeams}
        element={
          <PageGuard
            organizationLevelTypesRequired={{
              permissionType: PermissionType.Administration,
              organizationLevels: [
                { organizationLevelType: OrganizationLevelType.Company, multipleEntities: false },
                { organizationLevelType: OrganizationLevelType.Department, multipleEntities: false },
              ],
            }}
          >
            <DepartmentTeamsCMSPage />
          </PageGuard>
        }
      />
      <Route
        path={PagePath.userManagementDepartmentPeople}
        element={
          <PageGuard
            organizationLevelTypesRequired={{
              permissionType: PermissionType.Administration,
              organizationLevels: [
                { organizationLevelType: OrganizationLevelType.Company, multipleEntities: false },
                { organizationLevelType: OrganizationLevelType.Department, multipleEntities: false },
              ],
            }}
          >
            <DepartmentPeopleCMSPage />
          </PageGuard>
        }
      />

      <Route
        path={PagePath.userManagementTeams}
        element={
          <PageGuard
            organizationLevelTypesRequired={{
              permissionType: PermissionType.Administration,
              organizationLevels: [
                { organizationLevelType: OrganizationLevelType.Company, multipleEntities: false },
                { organizationLevelType: OrganizationLevelType.Department, multipleEntities: false },
                { organizationLevelType: OrganizationLevelType.Team, multipleEntities: true },
              ],
            }}
          >
            <CompanyTeamsCMSPage />
          </PageGuard>
        }
      />
      <Route
        path={PagePath.userManagementTeamPeople}
        element={
          <PageGuard
            organizationLevelTypesRequired={{
              permissionType: PermissionType.Administration,
              organizationLevels: [
                { organizationLevelType: OrganizationLevelType.Company, multipleEntities: false },
                { organizationLevelType: OrganizationLevelType.Department, multipleEntities: false },
                { organizationLevelType: OrganizationLevelType.Team, multipleEntities: false },
              ],
            }}
          >
            <TeamPeopleCMSPage />
          </PageGuard>
        }
      />
      <Route path={PagePath.rootWildcard} element={<ActiveCompanySlugRedirect landingRedirectTo={`${PagePath.userManagementBase}${PagePath.userManagementPeople}`} />} />
    </Routes>
  );
}
